import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import Typography from '../Typography';

const useStyles = makeStyles(
  () => ({
    leftLabel: {
      textAlign: 'left',
    },
    centerLabel: {
      textAlign: 'center',
    },
    rightLabel: {
      textAlign: 'right',
    },
  }),
  { name: 'CncUI-RadioGroup' },
);

const RadioGroup = props => {
  const classes = useStyles();
  const {
    children,
    className,
    label = '',
    labelAlign = 'left',
    labelProps = {},
    ...other
  } = props;
  const options = {
    className: clsx('cncui-radio-group', className),
  };

  if (label) {
    return (
      <FormControl component="fieldset">
        <FormLabel
          component="legend"
          className={clsx(
            'cncui-radio-group-label',
            classes[`${labelAlign}Label`],
          )}
        >
          <Typography variant="caption" {...labelProps}>
            {label}
          </Typography>
        </FormLabel>
        <MuiRadioGroup {...options} {...other}>
          {children}
        </MuiRadioGroup>
      </FormControl>
    );
  }

  return (
    <MuiRadioGroup {...options} {...other}>
      {children}
    </MuiRadioGroup>
  );
};

export default RadioGroup;
